import React from "react";
import { useNavigate } from "react-router-dom";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import StatTiles from "common-ui-components/components/stat-tiles/StatTiles";
import styles from "./PatchOverviewPanel.module.css";

const formatCount = (value, loading) =>
  loading || value == null ? "--" : Number(value).toLocaleString();

const TestAndApproveOverview = ({ overview, loading = false }) => {
  const navigate = useNavigate();
  const tiles = [
    {
      label: "Test & approve",
      value: formatCount(overview?.testAndApproveCount, loading),
      color: "#2e5bdc",
    },
    {
      label: "Awaiting approval",
      value: formatCount(overview?.awaitingApprovalPatches, loading),
      color: "#d97706",
    },
  ];

  return (
    <InfoBox
      header="Test & Approve"
      subtitle="Pilot testing and pending patch approvals"
      style={{ minWidth: 0 }}
      childrenProps={{ className: styles.panelContent }}
    >
      <p style={{
        color:"#56637a",
        fontSize:"14px"
      }}>
        Deploy patches to a pilot group first. Roll them out to other endpoints
        after successful validation and approval.
      </p>
      <StatTiles items={tiles} columns={2} />
      <button
        type="button"
        className={styles.actionLink}
        onClick={() => navigate("/app/secure/deployment/test-and-approve")}
      >
        Review pending approvals
      </button>
    </InfoBox>
  );
};

export default TestAndApproveOverview;
